// CryptoJS v3.1.2
var CryptoJS =
  CryptoJS ||
  (function (u, p) {
    var d = {},
      l = (d.lib = {}),
      s = function () {},
      t = (l.Base = {
        extend: function (a) {
          s.prototype = this;
          var c = new s();
          a && c.mixIn(a);
          c.hasOwnProperty("init") ||
            (c.init = function () {
              c.$super.init.apply(this, arguments);
            });
          c.init.prototype = c;
          c.$super = this;
          return c;
        },
        create: function () {
          var a = this.extend();
          a.init.apply(a, arguments);
          return a;
        },
        init: function () {},
        mixIn: function (a) {
          for (var c in a) a.hasOwnProperty(c) && (this[c] = a[c]);
          a.hasOwnProperty("toString") && (this.toString = a.toString);
        },
        clone: function () {
          return this.init.prototype.extend(this);
        },
      }),
      r = (l.WordArray = t.extend({
        init: function (a, c) {
          a = this.words = a || [];
          this.sigBytes = c != p ? c : 4 * a.length;
        },
        toString: function (a) {
          return (a || v).stringify(this);
        },
        concat: function (a) {
          var c = this.words,
            e = a.words,
            j = this.sigBytes;
          a = a.sigBytes;
          this.clamp();
          if (j % 4)
            for (var k = 0; k < a; k++)
              c[(j + k) >>> 2] |=
                ((e[k >>> 2] >>> (24 - 8 * (k % 4))) & 255) <<
                (24 - 8 * ((j + k) % 4));
          else if (65535 < e.length)
            for (k = 0; k < a; k += 4) c[(j + k) >>> 2] = e[k >>> 2];
          else c.push.apply(c, e);
          this.sigBytes += a;
          return this;
        },
        clamp: function () {
          var a = this.words,
            c = this.sigBytes;
          a[c >>> 2] &= 4294967295 << (32 - 8 * (c % 4));
          a.length = u.ceil(c / 4);
        },
        clone: function () {
          var a = t.clone.call(this);
          a.words = this.words.slice(0);
          return a;
        },
        random: function (a) {
          for (var c = [], e = 0; e < a; e += 4)
            c.push((4294967296 * u.random()) | 0);
          return new r.init(c, a);
        },
      })),
      w = (d.enc = {}),
      v = (w.Hex = {
        stringify: function (a) {
          var c = a.words;
          a = a.sigBytes;
          for (var e = [], j = 0; j < a; j++) {
            var k = (c[j >>> 2] >>> (24 - 8 * (j % 4))) & 255;
            e.push((k >>> 4).toString(16));
            e.push((k & 15).toString(16));
          }
          return e.join("");
        },
        parse: function (a) {
          for (var c = a.length, e = [], j = 0; j < c; j += 2)
            e[j >>> 3] |= parseInt(a.substr(j, 2), 16) << (24 - 4 * (j % 8));
          return new r.init(e, c / 2);
        },
      }),
      b = (w.Latin1 = {
        stringify: function (a) {
          var c = a.words;
          a = a.sigBytes;
          for (var e = [], j = 0; j < a; j++)
            e.push(
              String.fromCharCode((c[j >>> 2] >>> (24 - 8 * (j % 4))) & 255)
            );
          return e.join("");
        },
        parse: function (a) {
          for (var c = a.length, e = [], j = 0; j < c; j++)
            e[j >>> 2] |= (a.charCodeAt(j) & 255) << (24 - 8 * (j % 4));
          return new r.init(e, c);
        },
      }),
      x = (w.Utf8 = {
        stringify: function (a) {
          try {
            return decodeURIComponent(escape(b.stringify(a)));
          } catch (c) {
            throw Error("Malformed UTF-8 data");
          }
        },
        parse: function (a) {
          return b.parse(unescape(encodeURIComponent(a)));
        },
      }),
      q = (l.BufferedBlockAlgorithm = t.extend({
        reset: function () {
          this._data = new r.init();
          this._nDataBytes = 0;
        },
        _append: function (a) {
          "string" == typeof a && (a = x.parse(a));
          this._data.concat(a);
          this._nDataBytes += a.sigBytes;
        },
        _process: function (a) {
          var c = this._data,
            e = c.words,
            j = c.sigBytes,
            k = this.blockSize,
            b = j / (4 * k),
            b = a ? u.ceil(b) : u.max((b | 0) - this._minBufferSize, 0);
          a = b * k;
          j = u.min(4 * a, j);
          if (a) {
            for (var q = 0; q < a; q += k) this._doProcessBlock(e, q);
            q = e.splice(0, a);
            c.sigBytes -= j;
          }
          return new r.init(q, j);
        },
        clone: function () {
          var a = t.clone.call(this);
          a._data = this._data.clone();
          return a;
        },
        _minBufferSize: 0,
      }));
    l.Hasher = q.extend({
      cfg: t.extend(),
      init: function (a) {
        this.cfg = this.cfg.extend(a);
        this.reset();
      },
      reset: function () {
        q.reset.call(this);
        this._doReset();
      },
      update: function (a) {
        this._append(a);
        this._process();
        return this;
      },
      finalize: function (a) {
        a && this._append(a);
        return this._doFinalize();
      },
      blockSize: 16,
      _createHelper: function (a) {
        return function (b, e) {
          return new a.init(e).finalize(b);
        };
      },
      _createHmacHelper: function (a) {
        return function (b, e) {
          return new n.HMAC.init(a, e).finalize(b);
        };
      },
    });
    var n = (d.algo = {});
    return d;
  })(Math);
(function (u) {
  function p(b, n, a, c, e, j, k) {
    b = b + ((n & a) | (~n & c)) + e + k;
    return ((b << j) | (b >>> (32 - j))) + n;
  }
  function d(b, n, a, c, e, j, k) {
    b = b + ((n & c) | (a & ~c)) + e + k;
    return ((b << j) | (b >>> (32 - j))) + n;
  }
  function l(b, n, a, c, e, j, k) {
    b = b + (n ^ a ^ c) + e + k;
    return ((b << j) | (b >>> (32 - j))) + n;
  }
  function s(b, n, a, c, e, j, k) {
    b = b + (a ^ (n | ~c)) + e + k;
    return ((b << j) | (b >>> (32 - j))) + n;
  }
  for (
    var t = CryptoJS,
      r = t.lib,
      w = r.WordArray,
      v = r.Hasher,
      r = t.algo,
      b = [],
      x = 0;
    64 > x;
    x++
  )
    b[x] = (4294967296 * u.abs(u.sin(x + 1))) | 0;
  r = r.MD5 = v.extend({
    _doReset: function () {
      this._hash = new w.init([1732584193, 4023233417, 2562383102, 271733878]);
    },
    _doProcessBlock: function (q, n) {
      for (var a = 0; 16 > a; a++) {
        var c = n + a,
          e = q[c];
        q[c] =
          (((e << 8) | (e >>> 24)) & 16711935) |
          (((e << 24) | (e >>> 8)) & 4278255360);
      }
      var a = this._hash.words,
        c = q[n + 0],
        e = q[n + 1],
        j = q[n + 2],
        k = q[n + 3],
        z = q[n + 4],
        r = q[n + 5],
        t = q[n + 6],
        w = q[n + 7],
        v = q[n + 8],
        A = q[n + 9],
        B = q[n + 10],
        C = q[n + 11],
        u = q[n + 12],
        D = q[n + 13],
        E = q[n + 14],
        x = q[n + 15],
        f = a[0],
        m = a[1],
        g = a[2],
        h = a[3],
        f = p(f, m, g, h, c, 7, b[0]),
        h = p(h, f, m, g, e, 12, b[1]),
        g = p(g, h, f, m, j, 17, b[2]),
        m = p(m, g, h, f, k, 22, b[3]),
        f = p(f, m, g, h, z, 7, b[4]),
        h = p(h, f, m, g, r, 12, b[5]),
        g = p(g, h, f, m, t, 17, b[6]),
        m = p(m, g, h, f, w, 22, b[7]),
        f = p(f, m, g, h, v, 7, b[8]),
        h = p(h, f, m, g, A, 12, b[9]),
        g = p(g, h, f, m, B, 17, b[10]),
        m = p(m, g, h, f, C, 22, b[11]),
        f = p(f, m, g, h, u, 7, b[12]),
        h = p(h, f, m, g, D, 12, b[13]),
        g = p(g, h, f, m, E, 17, b[14]),
        m = p(m, g, h, f, x, 22, b[15]),
        f = d(f, m, g, h, e, 5, b[16]),
        h = d(h, f, m, g, t, 9, b[17]),
        g = d(g, h, f, m, C, 14, b[18]),
        m = d(m, g, h, f, c, 20, b[19]),
        f = d(f, m, g, h, r, 5, b[20]),
        h = d(h, f, m, g, B, 9, b[21]),
        g = d(g, h, f, m, x, 14, b[22]),
        m = d(m, g, h, f, z, 20, b[23]),
        f = d(f, m, g, h, A, 5, b[24]),
        h = d(h, f, m, g, E, 9, b[25]),
        g = d(g, h, f, m, k, 14, b[26]),
        m = d(m, g, h, f, v, 20, b[27]),
        f = d(f, m, g, h, D, 5, b[28]),
        h = d(h, f, m, g, j, 9, b[29]),
        g = d(g, h, f, m, w, 14, b[30]),
        m = d(m, g, h, f, u, 20, b[31]),
        f = l(f, m, g, h, r, 4, b[32]),
        h = l(h, f, m, g, v, 11, b[33]),
        g = l(g, h, f, m, C, 16, b[34]),
        m = l(m, g, h, f, E, 23, b[35]),
        f = l(f, m, g, h, e, 4, b[36]),
        h = l(h, f, m, g, z, 11, b[37]),
        g = l(g, h, f, m, w, 16, b[38]),
        m = l(m, g, h, f, B, 23, b[39]),
        f = l(f, m, g, h, D, 4, b[40]),
        h = l(h, f, m, g, c, 11, b[41]),
        g = l(g, h, f, m, k, 16, b[42]),
        m = l(m, g, h, f, t, 23, b[43]),
        f = l(f, m, g, h, A, 4, b[44]),
        h = l(h, f, m, g, u, 11, b[45]),
        g = l(g, h, f, m, x, 16, b[46]),
        m = l(m, g, h, f, j, 23, b[47]),
        f = s(f, m, g, h, c, 6, b[48]),
        h = s(h, f, m, g, w, 10, b[49]),
        g = s(g, h, f, m, E, 15, b[50]),
        m = s(m, g, h, f, r, 21, b[51]),
        f = s(f, m, g, h, u, 6, b[52]),
        h = s(h, f, m, g, k, 10, b[53]),
        g = s(g, h, f, m, B, 15, b[54]),
        m = s(m, g, h, f, e, 21, b[55]),
        f = s(f, m, g, h, v, 6, b[56]),
        h = s(h, f, m, g, x, 10, b[57]),
        g = s(g, h, f, m, t, 15, b[58]),
        m = s(m, g, h, f, D, 21, b[59]),
        f = s(f, m, g, h, z, 6, b[60]),
        h = s(h, f, m, g, C, 10, b[61]),
        g = s(g, h, f, m, j, 15, b[62]),
        m = s(m, g, h, f, A, 21, b[63]);
      a[0] = (a[0] + f) | 0;
      a[1] = (a[1] + m) | 0;
      a[2] = (a[2] + g) | 0;
      a[3] = (a[3] + h) | 0;
    },
    _doFinalize: function () {
      var b = this._data,
        n = b.words,
        a = 8 * this._nDataBytes,
        c = 8 * b.sigBytes;
      n[c >>> 5] |= 128 << (24 - (c % 32));
      var e = u.floor(a / 4294967296);
      n[(((c + 64) >>> 9) << 4) + 15] =
        (((e << 8) | (e >>> 24)) & 16711935) |
        (((e << 24) | (e >>> 8)) & 4278255360);
      n[(((c + 64) >>> 9) << 4) + 14] =
        (((a << 8) | (a >>> 24)) & 16711935) |
        (((a << 24) | (a >>> 8)) & 4278255360);
      b.sigBytes = 4 * (n.length + 1);
      this._process();
      b = this._hash;
      n = b.words;
      for (a = 0; 4 > a; a++)
        (c = n[a]),
          (n[a] =
            (((c << 8) | (c >>> 24)) & 16711935) |
            (((c << 24) | (c >>> 8)) & 4278255360));
      return b;
    },
    clone: function () {
      var b = v.clone.call(this);
      b._hash = this._hash.clone();
      return b;
    },
  });
  t.MD5 = v._createHelper(r);
  t.HmacMD5 = v._createHmacHelper(r);
})(Math);

const API_CONFIG = {
  BASE_PARAMS: {
    appkey: "6DCC55A836A246BEBAD583EBBA995ED1",
    grant_type: "password",
    scope: "server",
  },
  APP_SECRET: "DAC450E89BEB43B5B02CD6BE82B8C76E",
  CLIENT_TYPE: 3,
  LANGUAGE_ID: 7,
  SUCCESS_CODE: 2000,
  TIMEOUT: 10000,
  ENDPOINTS: {
    DEVICE_INFO:
      "https://official-web-api.topdon.com/api/v1/user/userDeviceApi/getDeviceInfoOpenInterface",
    PRODUCT_ADAPTATION:
      "https://official-web-api.topdon.com/api/snAdaptation/queryProductAdaptationModels",
  },
  ERROR_MESSAGES: {
    1001: {
      text: "Product information not found.",
      html: '<div style="line-height: 1.5;">Product information not found.<br><a href="/pages/contact" style="color: #588AEF; text-decoration: none;">Contact support</a> for assistance.</div>',
    },
    1002: "Product compatibility check failed. Please try again.",
    1003: "Invalid product data. Please verify your selection.",
  },
};

function randomString(len = 32) {
  const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  return Array.from({ length: len }, () =>
    chars.charAt(Math.floor(Math.random() * chars.length))
  ).join("");
}

function sort_ascii(obj) {
  return Object.keys(obj)
    .sort()
    .map((key) => `${key}=${obj[key]}`)
    .join("&");
}

function getSign(uri, param) {
  const timestamp = Date.now();
  const nonceStr = randomString(10);

  const paramData = {
    ...API_CONFIG.BASE_PARAMS,
    nonceStr,
    timestamp,
  };

  const signTemp = sort_ascii({ ...param, ...paramData });
  const hash = CryptoJS.MD5(`${signTemp}&appSecret=${API_CONFIG.APP_SECRET}`)
    .toString()
    .toUpperCase();

  return `${uri}?${signTemp}&sign=${hash}`;
}

function postWithSign(uri, headers, param, successCallback, errorCallback) {
  const url = getSign(uri, {});

  const requestHeaders = {
    "Content-Type": "application/json",
    clientType: API_CONFIG.CLIENT_TYPE,
    languageId: API_CONFIG.LANGUAGE_ID,
    ...headers,
  };

  fetch(url, {
    method: "POST",
    headers: requestHeaders,
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      if (data.code === API_CONFIG.SUCCESS_CODE) {
        successCallback(data.data || data);
      } else if (errorCallback) {
        errorCallback(data);
      }
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback({ msg: error.message });
      }
    });
}

if (!customElements.get("product-form-new")) {
  customElements.define(
    "product-form-new",
    class ProductFormNew extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.submitButtonCurrent =
          this.submitButton.querySelector("span").innerHTML;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.initializeCustomFeatures();
      }

      initializeCustomFeatures() {
        this.setAttribute("data-version", "new");
        this.addEventListener(
          "product-form-new:submit",
          this.handleCustomSubmit.bind(this)
        );
        this.setupInputErrorClearListeners();
      }

      handleCustomSubmit() {}

      setupInputErrorClearListeners() {
        const inputs = this.form.querySelectorAll(
          'input[type="text"], input[type="number"], input[type="email"], textarea'
        );

        inputs.forEach((input) => {
          input.addEventListener("input", (event) => {
            this.clearSingleInputError(event.target);
          });

          input.addEventListener("change", (event) => {
            this.clearSingleInputError(event.target);
          });
        });
      }

      /**
       * 清除单个输入框的错误状态
       * @param {HTMLElement} input - 输入框元素
       */
      clearSingleInputError(input) {
        if (!input) return;

        const hasError =
          input.style.borderColor === "#E32C2B" ||
          input.classList.contains("input-error");

        if (hasError) {
          input.style.borderColor = "";
          input.style.borderWidth = "";
          input.classList.remove("input-error");

          const errorElement = input.parentElement.querySelector(
            ".input-error-message"
          );
          if (errorElement) {
            errorElement.style.display = "none";
          }

          this.dispatchEvent(
            new CustomEvent("product-form-new:input-error-cleared", {
              detail: { input: input, fieldName: input.name },
              bubbles: true,
            })
          );
        }
      }

      /**
       * 设置按钮的 Loading 状态
       * @param {boolean} isLoading - true 显示 loading，false 隐藏 loading
       * @param {string} loadingText - 可选，loading 时显示的文字
       */
      setButtonLoading(isLoading, loadingText = null) {
        if (isLoading) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");

          const spinner = this.querySelector(".loading__spinner");
          if (spinner) {
            spinner.classList.remove("hidden");
          }

          if (loadingText && this.submitButtonText) {
            this.submitButtonText.textContent = loadingText;
          }

          this.dispatchEvent(
            new CustomEvent("product-form-new:loading-start", {
              bubbles: true,
            })
          );
        } else {
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");

          const spinner = this.querySelector(".loading__spinner");
          if (spinner) {
            spinner.classList.add("hidden");
          }

          if (this.submitButtonText && this.submitButtonCurrent) {
            this.submitButtonText.textContent = this.submitButtonCurrent;
          }
          this.dispatchEvent(
            new CustomEvent("product-form-new:loading-end", {
              bubbles: true,
            })
          );
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.clearInputErrors();

        this.setButtonLoading(true);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.dispatchEvent(
          new CustomEvent("product-form-new:before-submit", {
            detail: { formData: formData },
            bubbles: true,
          })
        );

        const formDataInfo = this.collectFormData(formData);

        try {
          const validation1Result = await this.validateAPI1(formDataInfo);

          if (!validation1Result.success) {
            this.showInputError(
              validation1Result.field,
              validation1Result.message
            );
            this.setButtonLoading(false);
            return;
          }

          const validation2Result = await this.validateAPI2(formDataInfo);

          if (!validation2Result.success) {
            this.showInputError(
              validation2Result.field,
              validation2Result.message,
              validation2Result.isHtml
            );
            this.setButtonLoading(false);
            return;
          }

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form-new",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButtonText.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;

                this.dispatchEvent(
                  new CustomEvent("product-form-new:error", {
                    detail: { response: response },
                    bubbles: true,
                  })
                );
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form-new",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }

              this.dispatchEvent(
                new CustomEvent("product-form-new:success", {
                  detail: { response: response },
                  bubbles: true,
                })
              );
            })
            .catch((e) => {
              this.dispatchEvent(
                new CustomEvent("product-form-new:error", {
                  detail: { error: e },
                  bubbles: true,
                })
              );
            })
            .finally(() => {
              this.setButtonLoading(false);
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");

              this.dispatchEvent(
                new CustomEvent("product-form-new:complete", {
                  bubbles: true,
                })
              );
            });
        } catch (error) {
          this.setButtonLoading(false);

          this.handleErrorMessage("Validation failed. Please try again.");

          this.dispatchEvent(
            new CustomEvent("product-form-new:error", {
              detail: { error: error },
              bubbles: true,
            })
          );
        }
      }

      async callAPIWithTimeout(
        apiCall,
        timeout = API_CONFIG.TIMEOUT,
        useUnifiedError = false,
        allowFailure = false
      ) {
        const unifiedErrorMessage =
          'The serial number you entered isn\'t compatible with this product. Please check our <a href="/pages/software-updates" style="color: #588AEF; text-decoration: none;">Software Updates</a> for compatible products.';
        return new Promise((resolve) => {
          const timeoutId = setTimeout(() => {
            // 如果允许失败，超时也返回成功
            if (allowFailure) {
              resolve({ success: true, data: {} });
            } else {
              resolve({
                success: false,
                field: "Tool Serial Number",
                message: useUnifiedError
                  ? unifiedErrorMessage
                  : "Request timeout. Please check your connection and try again.",
                isHtml: useUnifiedError,
              });
            }
          }, timeout);

          apiCall(
            (data) => {
              clearTimeout(timeoutId);
              resolve({ success: true, data });
            },
            (error) => {
              clearTimeout(timeoutId);
              // 检查是否是业务逻辑错误（有明确的错误消息）
              // 包括：modelId 不匹配、snStatus === 1 等
              const isBusinessError = error?.msg !== undefined;

              // 如果是业务逻辑错误，必须返回错误，不管 allowFailure 是什么
              if (isBusinessError) {
                resolve({
                  success: false,
                  field: "Tool Serial Number",
                  message: error.msg,
                  isHtml: error.isHtml || false,
                });
              } else if (allowFailure) {
                // 如果允许失败且不是业务逻辑错误，返回成功
                resolve({ success: true, data: {} });
              } else {
                resolve({
                  success: false,
                  field: "Tool Serial Number",
                  message:
                    error?.message ||
                    (useUnifiedError ? unifiedErrorMessage : "Request failed"),
                  isHtml: useUnifiedError,
                });
              }
            }
          );
        });
      }

      async validateAPI1(formDataInfo) {
        const serialNumber =
          formDataInfo.properties["Tool Serial Number"] || "";

        // 如果没有序列号，直接通过（不报错）
        if (!serialNumber) {
          return {
            success: true,
            data: {},
          };
        }
        const result = await this.callAPIWithTimeout(
          (onSuccess, onError) => {
            postWithSign(
              API_CONFIG.ENDPOINTS.DEVICE_INFO,
              {},
              { sn: serialNumber },
              (data) => {
                console.log("=== API1 响应 ===");
                console.log("API1 返回数据:", data);
                console.log("modelId:", data.modelId);
                console.log("snStatus:", data.snStatus);

                if (data.snStatus === 1) {
                  // snStatus 为 1 时需要阻止（报错）
                  console.log("❌ snStatus 为 1，无效的序列号");
                  onError({
                    msg: "Invalid serial number. Please check and try again.",
                    isHtml: false,
                  });
                  return;
                }
                onSuccess(data);
              },
              // 网络错误也直接通过（不报错）
              () => {
                console.log("API1 网络错误，直接通过");
                onSuccess({});
              }
            );
          },
          API_CONFIG.TIMEOUT,
          false,
          true
        );

        if (result.success) {
          this.deviceInfo = result.data;
          console.log("保存 deviceInfo:", this.deviceInfo);
        }

        return result;
      }

      async validateAPI2(formDataInfo) {
        const vendorCode = this.getVendorCode(formDataInfo);
        const unifiedErrorMessage =
          'The serial number you entered isn\'t compatible with this product. Please check our <a href="https://www.topdon.us/collections/software-updates" style="color: #588AEF; text-decoration: none;">Software Updates</a> for compatible products.';

        // 如果没有 vendorCode，直接通过（不报错）
        if (!vendorCode) {
          return {
            success: true,
            data: {},
          };
        }
        const result = await this.callAPIWithTimeout(
          (onSuccess, onError) => {
            postWithSign(
              API_CONFIG.ENDPOINTS.PRODUCT_ADAPTATION,
              {
                "x-requested-with": "Hiwie-Fetch",
              },
              // { vendorCode:'' },
              { vendorCode },
              (response) => {
                // 正确解析 API2 的响应数据结构
                const data =
                  response.success?.data || response.data || response;

                console.log("=== API2 验证开始 ===");
                console.log("API2 原始响应:", response);
                console.log("API2 解析后数据:", data);
                console.log("API1 deviceInfo:", this.deviceInfo);

                // 如果有 API 错误，直接通过（不报错）
                if (data.errorCode) {
                  console.log("API2 返回错误代码，直接通过");
                  onSuccess(data);
                  return;
                }

                // 如果没有 deviceInfo 或 modelId，直接通过（不报错）
                if (!this.deviceInfo || !this.deviceInfo.modelId) {
                  console.log("没有 deviceInfo 或 modelId，直接通过");
                  onSuccess(data);
                  return;
                }

                // 检查 API2 返回的适配模型列表
                const adaptationModels = data.adaptationModels || [];
                console.log("适配模型列表:", adaptationModels);

                // 如果没有适配模型列表，直接通过（不报错）
                if (!adaptationModels || adaptationModels.length === 0) {
                  console.log("没有适配模型列表，直接通过");
                  onSuccess(data);
                  return;
                }

                // 只有当适配模型列表中有 modelId，且与 API1 的 modelId 不匹配时才报错
                const hasModelIds = adaptationModels.some(
                  (model) =>
                    model.modelId !== undefined && model.modelId !== null
                );

                if (!hasModelIds) {
                  console.log("适配模型列表中没有 modelId，直接通过");
                  onSuccess(data);
                  return;
                }

                // 验证 API1 的 modelId 是否在 API2 的适配列表中
                const api1ModelId = this.deviceInfo.modelId;
                const api2ModelIds = adaptationModels.map((m) => m.modelId);

                console.log("API1 modelId:", api1ModelId);
                console.log("API2 modelIds:", api2ModelIds);

                const isCompatible = adaptationModels.some(
                  (model) => model.modelId === api1ModelId
                );

                console.log("是否兼容:", isCompatible);

                if (isCompatible) {
                  console.log("✅ modelId 匹配，验证通过");
                  onSuccess(data);
                } else {
                  console.log("❌ modelId 不匹配，显示错误");
                  onError({ msg: unifiedErrorMessage, isHtml: true });
                }
              },
              // 网络错误也直接通过（不报错）
              () => {
                onSuccess({});
              }
            );
          },
          API_CONFIG.TIMEOUT,
          false,
          true
        );

        return result;
      }

      getVendorCode(formDataInfo) {
        const analyticsVariant =
          window.ShopifyAnalytics?.meta?.product?.variants?.find(
            (v) => v.id === parseInt(formDataInfo.variantId)
          );
        if (analyticsVariant?.sku) {
          return analyticsVariant.sku;
        }

        const domSku = document.querySelector(
          `[data-variant-id="${formDataInfo.variantId}"]`
        )?.dataset?.sku;
        if (domSku) {
          return domSku;
        }

        if (formDataInfo.sku) {
          return formDataInfo.sku;
        }

        return null;
      }

      showInputError(fieldName, errorMessage, isHtml = false) {
        const input = this.form.querySelector(
          `[name="properties[${fieldName}]"]`
        );

        if (!input) return;

        input.style.borderColor = "#E32C2B";
        input.style.borderWidth = "1px";
        input.classList.add("input-error");

        let errorElement = input.parentElement.querySelector(
          ".input-error-message"
        );

        if (!errorElement) {
          errorElement = this.createErrorElement();
          input.parentElement.appendChild(errorElement);
        }

        if (isHtml) {
          errorElement.innerHTML = errorMessage;
        } else {
          errorElement.textContent = errorMessage;
        }
        errorElement.style.display = "block";

        this.dispatchEvent(
          new CustomEvent("product-form-new:input-error", {
            detail: { field: fieldName, message: errorMessage, isHtml },
            bubbles: true,
          })
        );
      }

      createErrorElement() {
        const errorElement = document.createElement("div");
        errorElement.className = "input-error-message";
        Object.assign(errorElement.style, {
          color: "#E32C2B",
          fontSize: "13px",
          marginTop: "0.5rem",
          fontWeight: "400",
          fontFamily:
            "ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color emoji",
        });
        return errorElement;
      }

      clearInputErrors() {
        const inputs = this.form.querySelectorAll(
          'input[type="text"], input[type="number"], input[type="email"], textarea'
        );

        inputs.forEach((input) => {
          input.style.borderColor = "";
          input.style.borderWidth = "";
          input.classList.remove("input-error");
        });

        const errorMessages = this.form.querySelectorAll(
          ".input-error-message"
        );
        errorMessages.forEach((msg) => {
          msg.style.display = "none";
        });
      }

      /**
       * 收集表单数据用于显示和验证
       * @param {FormData} formData - 表单数据对象
       * @returns {Object} 格式化的表单数据
       */
      collectFormData(formData) {
        const data = {
          variantId: formData.get("id"),
          quantity: formData.get("quantity") || "1",
          properties: {},
          allInputs: {},
        };

        // 提取 properties 字段
        for (const [key, value] of formData.entries()) {
          if (key.startsWith("properties[")) {
            const propertyName = key.match(/properties\[(.*?)\]/)?.[1];
            if (propertyName) {
              data.properties[propertyName] = value;
            }
          }
        }

        // 收集所有输入框的值
        const inputs = this.form.querySelectorAll(
          'input[type="text"], input[type="number"], input[type="email"], textarea'
        );
        inputs.forEach((input) => {
          if (input.name && input.value) {
            data.allInputs[input.name] = input.value;
          }
        });

        // 获取产品标题
        data.productTitle =
          this.form.querySelector('[name="product-title"]')?.value ||
          document.querySelector(".product__title")?.textContent?.trim() ||
          "Unknown Product";

        // 获取变体标题
        const variantSelect = this.form.querySelector('select[name="id"]');
        if (variantSelect) {
          const selectedOption =
            variantSelect.options[variantSelect.selectedIndex];
          data.variantTitle = selectedOption?.textContent?.trim() || "";
        }

        return data;
      }

      showFormDataAlert(data) {
        const messageParts = [
          "=== 表单提交信息 ===\n",
          "📦 产品信息:",
          `  产品名称: ${data.productTitle}`,
          data.variantTitle ? `  变体: ${data.variantTitle}` : null,
          `  Variant ID (SKU): ${data.variantId}`,
          `  数量: ${data.quantity}\n`,
        ].filter(Boolean);

        if (Object.keys(data.properties).length > 0) {
          messageParts.push("📝 自定义字段 (Properties):");
          Object.entries(data.properties).forEach(([key, value]) => {
            messageParts.push(`  ${key}: ${value}`);
          });
          messageParts.push("");
        }

        if (Object.keys(data.allInputs).length > 0) {
          messageParts.push("✏️ 所有输入框的值:");
          Object.entries(data.allInputs).forEach(([key, value]) => {
            messageParts.push(`  ${key}: ${value}`);
          });
        }

        alert(messageParts.join("\n"));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = this.submitButtonCurrent;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}

/**
 * Custom event listeners for Product Form (New)
 * You can add global event listeners here for all product-form-new instances
 */
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("product-form-new:success", () => {});

  document.addEventListener("product-form-new:error", () => {});
});
